export enum CategoryUploadStatusEnum {
  SUCCESS = 'SUCCESS',
  ERROR_CATEGORY = 'ERROR_CATEGORY',
  ERROR_ITEMS = 'ERROR_ITEMS',
}
